import React, { useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useSearchParams } from 'react-router-dom';

import CallMetrics from './child/DoughtnutChart';
import { getCallStats } from '../utils/api/callAPI';
import InvoiceSection from './InvoiceSection';
import PurchaseMetrics from './PurchaseMetrics';
import UnitCountSeven from './child/UnitCountSeven';
import TableDataLayer from '../pages/TableDataLayer';
import PurchaseComponent from './child/PurchaseComponent';

function BillingAndAddonsLayer() {
  const [numberOfCalls, setNumberOfCalls] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [invoices, setInvoices] = useState([]);
  const [purchaseData, setPurchaseData] = useState([]);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get('tab');
  const [selectedOption, setSelectedOption] = useState(tabParam || 'callMetrics');
  console.log(searchParams)
  useEffect(() => {
    getCallStats().then((data) => {
      setMinutes(Number(data?.totalMinutes?.toFixed(2)) || 0);
      setNumberOfCalls(data?.totalCalls || 0);
    });

    // Future integrations
    // getInvoices().then(setInvoices);
    // getPurchaseMetrics().then(setPurchaseData);
  }, []);

  useEffect(() => {
    if (tabParam && tabParam !== selectedOption) {
      setSelectedOption(tabParam);
    }
  }, [tabParam]);

  const toggleSidebar = () => setSidebarCollapsed((prev) => !prev);

  const handleTabChange = (tab) => {
    setSelectedOption(tab);
    setSearchParams({ tab })
  };

  // const renderContent = () => {
  //   switch (selectedOption) {
  //     case 'callMetrics':
  //       return <CallMetrics numberOfCalls={numberOfCalls} minutes={minutes} />;
  //     case 'invoice':
  //       return <InvoiceSection invoices={invoices} />;
  //     case 'purchaseMetrics':
  //       return <PurchaseMetrics purchaseData={purchaseData} />;
  //     default:
  //       return <div>Select a section</div>;
  //   }
  // };

  return (
    <div className="row gy-4">
      <div className="col-12" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        <UnitCountSeven />
        <PurchaseComponent/>
        <TableDataLayer />
      </div>
    </div>

  );
}

export default BillingAndAddonsLayer;
